const _excluded = ["newContact", "existingContact", "refreshExistingContacts", "onChange", "onValidation", "showCustomerDetailsWarning"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useState } from 'react';
import ContactPicker from "./ContactPicker";
import { ManageContactModalForVendor } from "../../ManageContactModal";
import { useGlobalContext } from 'seagull';
import { useStoreActions } from "../../../store/store-context";
import { handlePromise } from "../../../infra/utils";
import { contactModel } from "../../../models";
import { GridItem, TextButton } from 'seagull';
export default function ContactDetails(_ref) {
  let {
    newContact,
    existingContact,
    refreshExistingContacts,
    onChange: _onChange,
    onValidation,
    showCustomerDetailsWarning
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const hasPartialContactDetails = Boolean(newContact.firstName || newContact.lastName || newContact.companyName || newContact.email || newContact.phone);
  const globalContext = useGlobalContext();
  const {
    api
  } = useStoreActions();

  const calculateCanEditContact = () => existingContact && contactModel.isEditable(contactModel.edit(existingContact)) && !contactModel.isSample(existingContact);

  const [canEditContact, setCanEditContact] = useState(calculateCanEditContact());
  useEffect(() => {
    if (hasPartialContactDetails && !existingContact) {
      handlePromise(api.contact.create(newContact)).then(async _ref2 => {
        let [savedContact, responseErr] = _ref2;

        if (savedContact) {
          await newContactPostActions(savedContact);
        } else if (responseErr) {
          const savedContact = await openContactModal({
            newContactToCreate: newContact
          });
          await newContactPostActions(savedContact);
        }
      });
    }

    setCanEditContact(calculateCanEditContact());
  }, [existingContact]);

  const openContactModal = async props => {
    return globalContext.showModal({
      closeOnEscapeKey: false,
      closeOnClickOutside: false,
      content: _ref3 => {
        let {
          dismissModal
        } = _ref3;
        return /*#__PURE__*/React.createElement(ManageContactModalForVendor, _extends({}, props, {
          "data-testid": "manage-contact-modal",
          onClose: dismissModal,
          origin: "Agreement studio"
        }));
      }
    });
  };

  const newContactPostActions = async savedContact => {
    if (savedContact) {
      await refreshExistingContacts();
      onValidation(true);

      _onChange({
        type: 'existingContact',
        id: savedContact.id
      });
    } else {
      onValidation(false);

      _onChange({
        type: 'initial'
      });
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GridItem, {
    span: 9
  }, /*#__PURE__*/React.createElement(ContactPicker, {
    value: existingContact !== null && existingContact !== void 0 ? existingContact : newContact,
    onChange: async change => {
      switch (change.type) {
        case 'existingContact':
          onValidation(true);

          _onChange({
            type: 'existingContact',
            id: change.id
          });

          break;

        case 'newContact':
          {
            const savedContact = await openContactModal({});
            await newContactPostActions(savedContact);
            break;
          }

        case 'sampleContact':
          onValidation(true);

          _onChange({
            type: 'sampleContact'
          });

          break;

        case 'initial':
          onValidation(false);

          _onChange({
            type: 'initial'
          });

          break;

        default:
          break;
      }
    },
    "data-testid": props['data-testid'],
    error: showCustomerDetailsWarning,
    helperText: "Please select a contact"
  })), /*#__PURE__*/React.createElement(GridItem, {
    span: 3
  }, canEditContact && /*#__PURE__*/React.createElement(TextButton, {
    "data-testid": "edit-contact",
    onClick: async () => {
      const shouldRefresh = await openContactModal({
        existingContact
      });

      if (shouldRefresh) {
        await refreshExistingContacts();
      }
    }
  }, "Edit contact")));
}